import { getMeteringService } from '@landsbankinn/analytics-manager';
import { useResource } from '@landsbankinn/l16n';
import { UIKitContextProvider } from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import { THEME_GRID_IDP, zIndexConfig } from 'src/containers/config.ts';
import { useBrand } from 'src/hooks/useBrand';
import { useUIKitFontScale } from './useUIKitFontScale';

export function UIKitProvider(props: { children: ReactNode }) {
  useUIKitFontScale();
  const { r } = useResource();
  const brand = useBrand();
  return (
    <UIKitContextProvider
      zIndexConfig={zIndexConfig}
      r={r}
      themeGrid={THEME_GRID_IDP}
      meteringService={getMeteringService()}
      brand={brand}
    >
      {props.children}
    </UIKitContextProvider>
  );
}
